import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administrators',
  templateUrl: './administrators.component.html',
  styleUrls: ['./administrators.component.scss']
})
export class AdministratorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
